import { render, staticRenderFns } from "./middle2left.vue?vue&type=template&id=8f1e43f8&scoped=true&"
import script from "./middle2left.vue?vue&type=script&lang=js&"
export * from "./middle2left.vue?vue&type=script&lang=js&"
import style0 from "./middle2left.vue?vue&type=style&index=0&id=8f1e43f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1e43f8",
  null
  
)

export default component.exports